import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import UnknownDumbo from '../../Dumbo/Unknown';
import DeviationDumbView from '../../Dumbo';
import s from './Minimal.scss';
const Minimal = ({ deviation, onClick, width, height, className, style })=>/*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['root'], onClick && s['clickable-root'], className),
        alignItems: "center",
        justifyContent: "center",
        style: _object_spread({
            width,
            height
        }, style),
        onClick: onClick
    }, deviation && /*#__PURE__*/ React.createElement(DeviationDumbView, {
        className: s['dumbo'],
        deviation: deviation,
        width: width,
        height: height
    }), !deviation && /*#__PURE__*/ React.createElement(UnknownDumbo, {
        className: s['dumbo'],
        width: width,
        height: height
    }), /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: "tier",
        size: 24,
        className: s['badge']
    }));
Minimal.displayName = 'Minimal';
export default Minimal;

//# sourceMappingURL=Minimal.js.map